import { Text } from "@mantine/core"
import { useSelector } from "react-redux"
import { IGeneral } from "../../../store/General"

type Props = { code: string | null | undefined }

/** PO type is plain text in lists (Ord_Purchase), not an outlined pill. */
export function PurchaseTypeBadge({ code }: Props) {
  const orderPurchaseTypes = useSelector((s: { general: IGeneral }) => s.general.orderPurchaseTypes)
  const name = orderPurchaseTypes.find((c) => c.code === code)?.name
  return <Text fz={14} c="dark.6" style={{ whiteSpace: "nowrap" }}>{name ?? "-"}</Text>
}
